import React from 'react';
interface StatusBadgeProps {
  status: string;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  let bg = 'bg-mist/30';
  let text = 'text-stone';
  const s = status.toLowerCase();
  if (['paid', 'confirmed', 'active', 'presencial', 'attended', 'studio'].includes(s)) {
    bg = 'bg-success/10';
    text = 'text-success';
  } else if (['cancelled', 'failed', 'no_show', 'full'].includes(s)) {
    bg = 'bg-error/10';
    text = 'text-error';
  } else if (['pending', 'park', 'outdoor'].includes(s)) {
    bg = 'bg-warning/10';
    text = 'text-warning';
  } else if (['virtual', 'zoom', 'online'].includes(s)) {
    bg = 'bg-virtual-light';
    text = 'text-virtual';
  } else if (['privada', 'grupal'].includes(s)) {
    bg = 'bg-earth/10';
    text = 'text-earth';
  }
  const displayStatus = s.replace('_', ' ');
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${bg} ${text}`} data-id="element-640">
      {displayStatus}
    </span>;
}